'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import Select from '../_utils/select-wrapper';

// -----------------------------------------------------------
//  OptionSelector
// -----------------------------------------------------------
const OptionSelector = ({id, name, options, selected, onChange}) => {
  options = options.map((option) => {
    return {
      label: option.name,
      value: option.value,
      isDefault: option.is_default
    };
  });

  const handleChange = (value) => {
    onChange(id, value)
  };

  const optionValue = () => {
    return selected ||
            (options.find(option => option.isDefault) || {}).value ||
            (options[0] && options[0].value)
  };

  return (
      <div className="filter">
        <h4>{ name }</h4>
        <Select options={ options }
                value={ optionValue() }
                onChange={ handleChange } />
      </div>
  );
};


export default OptionSelector;
